/* istanbul ignore file */
import { TextArea, TextInput, useFormContext } from 'framework/form';
import { SubmitButton } from 'framework/ui/ui-builder';
import { Button } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';

interface TerminateProcessFormProps {
  handleCancelClick: () => void;
}

const TerminateProcessForm = ({ handleCancelClick }: TerminateProcessFormProps) => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact } = useFormContext();

  return (
    <>
      <TextInput source="instanceId" label="Process instance id" isRequired disabled />
      <TextArea source="reason" label="Terminate process reason" isRequired />
      <Box display="flex" gap={1.25}>
        <SubmitButton
          key="submit-modal-btn"
          onClick={submitForm}
          isLoading={!isSubmitEnabled}
          disabled={isLoadingArtifact}
        />
        <Button
          variant="outlined"
          key="cancel-modal-btn"
          onClick={handleCancelClick}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
};

export default TerminateProcessForm;
